"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _styles = require("@material-ui/core/styles");
var _SttModal = _interopRequireDefault(require("../../../SttModal"));
var _SttInput = _interopRequireDefault(require("../../../SttInput/SttInput"));
var _SttButton = _interopRequireDefault(require("../../../SttButton/SttButton"));
var _SttCircularProgress = _interopRequireDefault(require("../../../SttCircularProgress"));
var _SttAssistenteMarkdown = _interopRequireDefault(require("./SttAssistenteMarkdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ROLE_USUARIO = 'user';
var ROLE_ASSISTENTE = 'assistant';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    conversa: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      minHeight: '300px',
      maxHeight: '50vh',
      overflowY: 'auto',
      padding: theme.spacing(1)
    },
    mensagemUsuario: {
      alignSelf: 'flex-end',
      backgroundColor: '#cee1f4',
      borderRadius: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
      maxWidth: '85%',
      whiteSpace: 'pre-wrap',
      overflowWrap: 'break-word'
    },
    mensagemAssistente: {
      alignSelf: 'flex-start',
      backgroundColor: '#f0f0f0',
      borderRadius: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
      maxWidth: '85%',
      overflowWrap: 'break-word',
      '& p': {
        margin: '0 0 0.5em',
        '&:last-child': {
          marginBottom: 0
        }
      },
      '& h1, & h2, & h3, & h4, & h5, & h6': {
        fontSize: '1em',
        fontWeight: 700,
        lineHeight: 1.3,
        margin: '0.7em 0 0.35em',
        '&:first-child': {
          marginTop: 0
        }
      },
      '& ul, & ol': {
        margin: '0.35em 0',
        paddingLeft: '1.4em'
      },
      '& li': {
        margin: '0.15em 0'
      },
      '& strong, & b': {
        fontWeight: 700
      },
      '& em, & i': {
        fontStyle: 'italic'
      },
      '& code': {
        fontFamily: 'monospace',
        fontSize: '0.9em',
        backgroundColor: 'rgba(0, 0, 0, 0.06)',
        padding: '0 0.25em',
        borderRadius: 3
      },
      '& pre': {
        overflowX: 'auto',
        backgroundColor: 'rgba(0, 0, 0, 0.06)',
        padding: theme.spacing(1),
        borderRadius: 4,
        margin: '0.5em 0',
        '& code': {
          backgroundColor: 'transparent',
          padding: 0
        }
      },
      '& blockquote': {
        margin: '0.4em 0',
        paddingLeft: theme.spacing(1.5),
        borderLeft: '3px solid #ccc'
      },
      '& table': {
        borderCollapse: 'collapse',
        width: '100%',
        margin: '0.5em 0'
      },
      '& th, & td': {
        border: '1px solid #ccc',
        padding: '0.25em 0.5em',
        textAlign: 'left'
      }
    },
    boasVindas: {
      color: theme.palette.text.secondary,
      textAlign: 'center',
      margin: theme.spacing(4, 0)
    },
    pensando: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      alignSelf: 'flex-start',
      color: theme.palette.text.secondary,
      padding: theme.spacing(1)
    },
    erro: {
      color: theme.palette.error.main,
      padding: theme.spacing(0, 1)
    },
    envio: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'flex-start',
      marginTop: theme.spacing(1)
    },
    campoPergunta: {
      flex: 1
    }
  };
});
var gerarIdConversa = function gerarIdConversa() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "conv-".concat(Date.now(), "-").concat(Math.random().toString(16).slice(2));
};
var SttAssistenteChat = function SttAssistenteChat(_ref) {
  var aberto = _ref.aberto,
    onFechar = _ref.onFechar,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? {} : _ref$headers;
  var classes = useStyles();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    mensagens = _useState2[0],
    setMensagens = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    texto = _useState4[0],
    setTexto = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    perguntaEmAndamento = _useState6[0],
    setPerguntaEmAndamento = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    erro = _useState8[0],
    setErro = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    idConversa = _useState10[0],
    setIdConversa = _useState10[1];
  var fimConversaRef = (0, _react.useRef)(null);
  var urlBase = config.assistente && config.assistente.url_base || '';
  var titulo = config.assistente && config.assistente.titulo || 'Assistente';
  var mensagemBoasVindas = config.assistente && config.assistente.mensagem_boas_vindas || 'Faça uma pergunta. O assistente responde com base nos dados agregados do módulo.';
  (0, _react.useEffect)(function () {
    if (aberto) {
      setMensagens([]);
      setTexto('');
      setErro(null);
      setPerguntaEmAndamento(false);
      setIdConversa(gerarIdConversa());
    }
  }, [aberto]);
  (0, _react.useEffect)(function () {
    if (fimConversaRef.current) {
      fimConversaRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [mensagens, perguntaEmAndamento]);
  var fechar = function fechar() {
    if (idConversa && urlBase) {
      _axios["default"].post("".concat(urlBase, "/assistente/conversa/encerrar"), {
        id_conversa: idConversa
      }, {
        headers: headers
      })["catch"](function () {});
    }
    setMensagens([]);
    setTexto('');
    setErro(null);
    setIdConversa(null);
    if (onFechar) {
      onFechar();
    }
  };
  var onEnviarPergunta = function onEnviarPergunta() {
    var conteudo = texto.trim();
    if (!conteudo || perguntaEmAndamento || !urlBase) {
      return;
    }
    var conversaAtual = idConversa || gerarIdConversa();
    if (!idConversa) {
      setIdConversa(conversaAtual);
    }
    var novasMensagens = [].concat(_toConsumableArray(mensagens), [{
      role: ROLE_USUARIO,
      content: conteudo
    }]);
    setMensagens(novasMensagens);
    setTexto('');
    setErro(null);
    setPerguntaEmAndamento(true);
    _axios["default"].post("".concat(urlBase, "/assistente/pergunta"), {
      mensagens: novasMensagens,
      id_conversa: conversaAtual
    }, {
      headers: headers
    }).then(function (response) {
      setMensagens(function (atuais) {
        return [].concat(_toConsumableArray(atuais), [{
          role: ROLE_ASSISTENTE,
          content: response.data.resposta
        }]);
      });
    })["catch"](function (err) {
      setErro(err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Não foi possível obter a resposta do assistente. Tente novamente.');
    })["finally"](function () {
      setPerguntaEmAndamento(false);
    });
  };
  var onTeclaCampoPergunta = function onTeclaCampoPergunta(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onEnviarPergunta();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SttModal["default"], {
    title: titulo,
    open: aberto,
    maxWidth: "lg",
    fullWidth: true,
    outModalClose: fechar,
    iconClose: fechar,
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.conversa
    }, mensagens.length === 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.boasVindas
    }, mensagemBoasVindas), mensagens.map(function (mensagem, indice) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: indice,
        className: mensagem.role === ROLE_USUARIO ? classes.mensagemUsuario : classes.mensagemAssistente
      }, mensagem.role === ROLE_ASSISTENTE ? /*#__PURE__*/_react["default"].createElement(_SttAssistenteMarkdown["default"], {
        texto: mensagem.content
      }) : mensagem.content);
    }), perguntaEmAndamento && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.pensando
    }, /*#__PURE__*/_react["default"].createElement(_SttCircularProgress["default"], {
      size: 18
    }), "Pensando..."), /*#__PURE__*/_react["default"].createElement("div", {
      ref: fimConversaRef
    })), erro && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.erro
    }, erro), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.envio
    }, /*#__PURE__*/_react["default"].createElement(_SttInput["default"], {
      className: classes.campoPergunta,
      placeholder: "Digite sua pergunta e pressione Enter",
      value: texto,
      onChange: function onChange(event) {
        return setTexto(event.target.value);
      },
      onKeyDown: onTeclaCampoPergunta,
      disabled: perguntaEmAndamento,
      autoFocus: true
    }), /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "contained",
      color: "primary",
      onClick: onEnviarPergunta,
      disabled: perguntaEmAndamento || !texto.trim()
    }, "Enviar")))
  });
};
var _default = SttAssistenteChat;
exports["default"] = _default;